<template lang="pug">
    el-dialog(:title="ruleForm.type=='add' ? '发布预约': ruleForm.type=='update' ?'修改预约':'复制并新建'", width="95%",:visible.sync='visible' :append-to-body="true" :modal-append-to-body='false' @close="closeForm()")
        <el-card shadow="never">
            <span class="fontStyle">教练基本信息</span>
        </el-card>
        el-form(:model="coachForm" :inline="false" :rules="rules" ref="coachFormRef" label-width="90px" label-position='right' @submit.native.prevent)
          el-card(shadow="never")
            div
                el-form-item(label="教练姓名:" prop="coachName")
                    el-select.inputWidths(v-model='coachForm.coachName'  placeholder="请选择教练姓名" clearable @change="changeCity")
                        el-option(v-for="(item,index) in coachList" :key="index" :label="item.label" :value="item.value" )
                el-form-item(label="手机号码:" prop="phone")
                    el-input.inputWidths(v-model='coachForm.phone' disabled  placeholder="" type="text" )
                el-form-item(label="等级:" prop="leve" placeholder="请输入等级")
                    el-input.inputWidths(v-model='coachForm.leve' disabled  type="text" )
                el-form-item(label="级别:" prop="coachLevel")
                    el-select.inputWidths( v-model='coachForm.coachLevel' disabled placeholder='' clearable)
                        el-option(v-for="(item,index) in levelOptions" :label="item.label" :value="item.value" )
                el-form-item(label="性别:" prop="sex" )
                    el-radio-group(v-model="coachForm.sex" disabled)
                        el-radio(label="0") 男
                        el-radio(label="1") 女
                el-form-item(label="授课时数:" prop="classNum")
                    el-input.inputWidths(v-model='coachForm.classNum' disabled  type="text" )
                el-form-item(label="教练资质:" prop="coachQualifications")
                    el-input.inputWidths(v-model='coachForm.coachQualifications' disabled  type="text" )
                el-form-item(label="教练标签:" prop="coachLabel")
                    el-input.inputWidths(v-model='coachForm.coachLabel' disabled  type="text" )
                    //- <div class='lab'>
                    //-   <span>123</span>
                    //- </div>
                el-form-item(label="教练头像:" prop="imageUrl")
                    <img :src="coachForm.imageUrl" :onerror="defaultImg" style="width:245px;height:178px;"/>
                el-form-item(label='运动经历'  prop="sportExperience")
                         el-input.width_ct(v-html="coachForm.sportExperience" clearable type="textarea" disabled :rows=6 placeholder="")

        <el-card shadow="never">
            <span class="fontStyle">课程信息</span>
            //- <div slot="header" class="clearfix">

            //- </div>
        </el-card>
            el-form(:model="courseInfo" :inline="false" :rules="courseRules" ref="courseInfoRef" label-width="90px" label-position='right' @submit.native.prevent)
                el-card(shadow="never")
                    div
                        el-form-item(label='课程名称' prop="name")
                            el-input.width_ct(v-model='courseInfo.name' @input="descInput" placeholder='请填写课程名称' maxlength="40" show-word-limit clearable)
                            font.font_later 您还可以输入
                            font.font_style {{nameFont}}
                            font.font_color 个字!
                        el-form-item(label="班级人数:" prop="count")
                            el-input.inputWidths(v-model='courseInfo.count'  placeholder="请输入班级人数" type="text" )
                        el-form-item(label="会员级别:" prop="memberLevel")
                            el-select.inputWidths( v-model='courseInfo.memberLevel' placeholder='请选择会员级别' clearable)
                                el-option(v-for="(item,index) in levelOptions" :label="item.label" :value="item.value" )
                        el-form-item(label="课时费:" prop="hourFee")
                            el-input.inputWidths(v-model='courseInfo.hourFee' placeholder="请输入课时费"  type="text" )
                            <span class="costnumber">元/人</span>
                        el-form-item(label='课程内容' prop="content")
                             el-input.width_ct(v-model="courseInfo.content" clearable type="textarea" :rows=6 placeholder='请输入课程内容')
            el-form(:model="ruleForm", :inline="false" :rules="rules", ref="addFrom", label-width="100px")
                el-card(shadow="never")
                    div(slot="header")
                        font(style="font-weight: bold;font-size:18px;") 预约时间及场地设置
                    div
                        //- el-row(style="padding-bottom:15px;" :span="24")
                        //-     el-col(:md='23' :sm="5")
                                el-button(@click='addFeeTemplate(2)'  type='primary') 选择模板
                        el-row
                            el-col(:span='6')
                                el-form-item(label="可预约日期:")
                                    el-date-picker(v-model="classSeting.date" placeholder="请先填选时间"  type="date"  format="yyyy-MM-dd" value-format="yyyy-MM-dd" @blur="pxTimeSd" :picker-options="pickerOptionsPxrq"  clearable)
                            el-col(:span='6')
                                el-form-item(label="时段")
                                    el-time-select(v-model='classSeting.strTime'  style='width:115px',
                                    :disabled="!classSeting.date"
                                    @change="strTimeChange"  :picker-options="{start: '00:00',step: '00:05',end: '24:00',minTime:pxmintime}")
                                    font &nbsp;—&nbsp;
                                    el-time-select(v-model='classSeting.endTime'  style='width:115px',
                                    :disabled="!classSeting.strTime" :picker-options="{start: classSeting.strTime,step: '00:05',end: '24:00',minTime:classSeting.strTime}")
                            el-col(:span='6')
                                el-form-item(label="可预约场地:")
                                    el-input(style='width:220px;' v-model="classSeting.spaceName" maxlength='40' @blur="spaceNameBlur")
                            el-col(:span='6')
                                div(style="float:right")
                                    el-button(type="primary" @click="addClaseSeting" :disabled="(ruleForm.type == 1)&&(ruleForm.trainCourseList.length>=1)") 添加
                                    el-button(type="danger" @click="delClassSeting" :disabled="checkedClass.length<1") 删除
                        el-table(:data="ruleForm.trainCourseList" @selection-change="classCheck" border)
                            el-table-column(type='selection', header-align='center', align='center', width='50')
                            el-table-column(type="index" label="序号" align='center' width='150')
                            el-table-column(prop="date" label="预约日期" align='center')
                            //- el-table-column(prop="strTime" label="开始时间" align='center')
                            //- el-table-column(prop="endTime" label="结束时间" align='center')
                            el-table-column(prop="time" label="预约时间段" align='center')
                            el-table-column(prop="spaceName" label="预约场地" align='center')
                el-card(shadow="never")
                br
                el-card(shadow="never")
                    div(slot="header")
                        font(style="font-weight: bold;font-size:18px;") 退款设置
                    div
                        el-row(style="padding-bottom:15px;" :span="24")
                            el-col(:md='23' :sm="5")
                                el-button(@click='addFeeTemplate(2)'  type='primary') 选择模板
                        el-row
                        el-col(:span="8")
                                el-form-item(label="距预约开始≤" label-width="auto")
                                    el-input-number(v-model="tMoneyStr" :min="0" :max="100000000" :step="1")
                                    font &nbsp;&nbsp;&nbsp;小时
                        el-col(:span="8")
                                el-form-item(label="退款比例:")
                                    el-input-number(v-model="tmoneyBL" :min="0" :max="100")
                                    font &nbsp;&nbsp;&nbsp;%
                        el-col(:span="8" )
                                div(style="float:right")
                                    el-button(@click="addCtRefund" type="primary") 添 加
                                    el-button(@click="delCtRefund" type="danger" :disabled="delCtRefundDisabled") 删 除
                        el-table(:data="ruleForm.trainRefundList" border @selection-change='selectionChangeHandle')
                            el-table-column(type='selection', align='center', width='50')
                            el-table-column(type="index" label="序号"  align='center', width='100')
                            el-table-column(prop="hours" label="距预约开始时间/小时（含）" align='center')
                            el-table-column(prop="rate" label="退款比例/%" align='center')
                            //- 选择模板
                            add-fee-template(v-if='addFeeTemplateVisible', ref="addFeeTemplate", @chooseTemplate='chooseTemplate')
        span.dialog-footer(slot="footer")
            el-button(type="primary" @click="coachFormSubmit()" :loading="loading") 确 定
            el-button(@click="closeForm()") 取 消
</template>
<script>
export default {
  name: 'ReleaseReserve',
  data () {
    return {
      loading: false, //提交缓存
      addFeeTemplateVisible: false,
      visible: false,
      defaultImg: '',
      dataForm: { name: '' },
      nameFont: 40,
      ctRefundParmas: {},
      sitePriceDetailParams: {},
      siteDetailData: [],
      refundData: [],
      memberTypeArray: [], // 接口获取可以参考约场地新增操作
      coachForm: {
        // 教练基本信息
        id: null,
        coachName: '', // 教练姓名
        phone: '', // 手机号码
        leve: '', // 等级
        coachLevel: '', // 级别
        sex: '', // 性别
        classNum: '', // 授课时数
        coachQualifications: '', // 教练资质
        coachLabel: '', // 教练标签
        imageUrl:
          'https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg',
        sportExperience: '',
        label: ''
      },
      courseInfo: {
        name: '', // 课程名称
        count: '', // 班级人数
        memberLevel: '', // 会员级别
        hourFee: '', // 课时费
        content: '' // 课程内容
      },
      levelOptions: [
        { value: '不限', label: '不限' },
        { value: '0.0', label: '0.0' },
        { value: '1.0', label: '1.0' },
        { value: '1.5', label: '1.5' },
        { value: '2.0', label: '2.0' },
        { value: '2.5', label: '2.5' },
        { value: '3.0', label: '3.0' },
        { value: '3.5', label: '3.5' },
        { value: '4.0', label: '4.0' },
        { value: '4.5', label: '4.5' },
        { value: '5.0', label: '5.0' }
      ],
      coachList: [], //教练姓名列表
      rules: {
        coachName: [
          { required: true, message: '教练姓名不能为空!', trigger: 'change' }
        ],
        phone: [
          //   { required: true, message: '教练姓名不能为空!', trigger: 'blur' }
        ],
        coachLevel: [
          //   { required: true, message: '级别不能为空', trigger: 'change' }
        ],
        sex: [
          // { required: true, message: '性别不能为空!', trigger: 'blur' }
        ],
        classNum: [
          //   { required: true, message: '授课时数不能为空!', trigger: 'blur' }
        ],
        coachQualifications: [
          //   { required: true, message: '教练资质不能为空!', trigger: 'blur' }
        ],
        coachLabel: [
          //   { required: true, message: '教练标签不能为空!', trigger: 'blur' }
        ],
        imageUrl: [
          //   { required: true, message: '教练照片不能为空!', trigger: 'blur' }
        ],
        sportExperience: [
          //   { required: true, message: '运动经历不能为空!', trigger: 'blur' }
        ]
      },
      courseRules: {
        name: [
          { required: true, message: '课程名称不能为空!', trigger: 'blur' }
        ],
        count: [
          { required: true, message: '班级人数不能为空!', trigger: 'blur' }
        ],
        memberLevel: [
          { required: true, message: '会员级别不能为空!', trigger: 'change' }
        ],
        hourFee: [
          { required: true, message: '课时费不能为空!', trigger: 'blur' }
        ],
        content: [
          { required: true, message: '课程内容不能为空!', trigger: 'blur' }
        ]
      },
      classSeting: {
        code: 0,
        date: '',
        strTime: '',
        endTime: '',
        spaceName: '',
        time: ''
      },
      pickerOptionsPxrq: null,
      pxmintime: '00:00',
      checkedClass: [], //勾选的课程
      ruleForm: {
        type: 1, //新增培训类型(1:单次 2：整期 3：青少年 4：个人定制化 5：团体定制化
        id: null,
        name: '',
        level: '',
        applyEndTime: '',
        // 课程设置
        trainCourseList: [], //课程设置列表
        //退款设置
        trainRefundList: []
      },
      tMoneyStr: null,
      tmoneyBL: null,
      delCtRefundDisabled: true,
      pickerOptionsCt: null,
      //   表单验证
      coachFormRefTS: false,
      courseInfoRefTS: false
    }
  },
  created () {
    this.getMemberTypeList()
    this.getDataList()
    this.pickerOptionsPxrq = {
      disabledDate: (time) => {
        return time < new Date(new Date().getTime() - 59 * 60 * 24 * 1000)
      }
    }
  },
  methods: {
    // 新增和修改方法
    coachFormSubmit () {
      console.log(this.ruleForm)
      this.Testing()
      this.$nextTick(() => {
        // if (!this.coachFormRefTS) {
        //   this.$message.error('教练基本信息不能为空！')
        //   return
        // }
        // if (!this.courseInfoRefTS) {
        //   this.$message.error('课程信息不能为空！')
        //   return
        // }
        if (this.ruleForm.trainCourseList.length > 0 === false) {
          this.$message.error('预约时间及场地设置不能为空！')
          return
        }
        if (this.ruleForm.trainRefundList.length > 0 === false) {
          this.$message.error('应至少设置一条退费规则！')
          return
        }
        if (this.coachFormRefTS && this.courseInfoRefTS) {
          let obj = {
            businessRefundDTOList: this.ruleForm.trainRefundList,
            coachId: this.coachForm.id,
            subscribeCoachCourse: this.courseInfo,
            subscribeCoachTimeDTOS: this.ruleForm.trainCourseList
          }
          let obj1 = {
            // id: this.ruleForm.id,
            // pxSubscribeCoachUpdateDTO: {
            id: this.ruleForm.id,
            businessRefundDTOList: this.ruleForm.trainRefundList,
            coachId: this.coachForm.id,
            courseDeleteIds: this.courseInfo.id, //删除的课程主键
            refundDeleteIds: this.getIdArray(this.ruleForm.trainRefundListsave), //删除的退款主键
            timeDeleteIds: this.getIdArray(this.ruleForm.trainCourseListsave), //删除的时间主键
            subscribeCoachCourse: this.courseInfo,
            subscribeCoachTimeDTOS: this.ruleForm.trainCourseList
            // }
          }
          //   新增
          if (
            this.ruleForm.type === 'add' ||
            this.ruleForm.type === 'copyNew'
          ) {
            this.loading = true
            this.$http({
              url: this.$http.adornUrl('/pxSubscribe/save'),
              method: 'post',
              data: obj
            }).then((data) => {
              if (data.code === 0) {
                this.$emit('refreshgetDataList')
                this.$message({
                  message: '新建成功',
                  type: 'success',
                  duration: 1500,
                  onClose: () => {
                    this.closeForm()
                  }
                })
              } else {
                this.$message({
                  type: 'warning',
                  message: '新建失败'
                })
                setTimeout(() => {
                  this.loading = false
                }, 1000)
              }
              // this.dataListLoading = false
            })
            // 修改
          } else if (this.ruleForm.type === 'update') {
            this.loading = true
            this.$http({
              url: this.$http.adornUrl('/pxSubscribe/update'),
              method: 'post',
              data: obj1
            }).then((data) => {
              if (data.code === 0) {
                this.$emit('refreshgetDataList')
                this.$message({
                  message: '修改成功',
                  type: 'success',
                  duration: 1500,
                  onClose: () => {
                    this.closeForm()
                  }
                })
              } else {
                this.$message({
                  type: 'warning',
                  message: '修改失败'
                })
                setTimeout(() => {
                  this.loading = false
                }, 1000)
              }
              // this.dataListLoading = false
            })
          }
        }
      })
    },
    // 表格验证
    Testing () {
      this.$refs['coachFormRef'].validate((valid) => {
        this.coachFormRefTS = valid
        // return
      })
      this.$refs['courseInfoRef'].validate((valid) => {
        this.courseInfoRefTS = valid
      })
    },
    // 获取会员类型列表
    getMemberTypeList () {
      this.$http({
        url: this.$http.adornUrl('/bp-book-places/member-type-list'),
        method: 'get'
      }).then((res) => {
        const { data } = res
        this.memberTypeArray = data
      })
    },
    // 获取教练列表
    getDataList () {
      //   this.dataListLoading = true
      this.$http({
        url: this.$http.adornUrl('/pxCoach/list'),
        method: 'post',
        data: {
          page: 1,
          rows: 100,
          name: this.dataForm.name || null,
          phone: this.dataForm.phone || null,
          cardNum: this.dataForm.cardNum || null,
          userGroupId: this.dataForm.userGroupId || null,
          coachLevel: this.dataForm.coachLevel || null,
          sex: this.dataForm.sex || null,
          limit: 100
        }
      }).then((data) => {
        if (data && data.code === 0) {
          this.coachList = []
          let item = data.page.records
          let arr = {
            value: '1',
            label: '教练1'
          }
          for (var i = 0; i < item.length; i++) {
            arr = {
              value: item[i].id,
              label: item[i].name
            }
            this.coachList.push(arr)
          }
        } else {
          this.tableData = []
          this.totalPage = 0
        }
        // this.dataListLoading = false
      })
    },
    // 选择教练
    changeCity (id) {
      let ids = id || this.coachForm.coachName
      this.$http({
        url: this.$http.adornUrl(`/pxCoach/getId/` + ids),
        method: 'get'
      }).then((data) => {
        if (data && data.code === 0) {
          let coachForm = {
            // 教练基本信息
            id: data.bean.id,
            coachName: data.bean.name, // 教练姓名
            phone: data.bean.phone, // 手机号码
            leve: data.bean.leve, // 等级
            coachLevel: data.bean.coachLevel, // 级别
            sex: data.bean.sex + '', // 性别
            classNum: data.bean.classHours, // 授课时数
            coachQualifications: data.bean.intelligence, // 教练资质
            coachLabel: data.bean.label, // 教练标签
            imageUrl: data.bean.headPortrait,
            sportExperience: data.bean.sportsExperience
          }
          this.coachForm = coachForm
        }
      })
    },
    descInput () {
      // 判断还能写多少字符得
      let len = 40 - this.dataForm.name.length
      this.nameFont = len
    },
    init (type, id) {
      this.visible = true
      //新增培训类型 type (1:单次 2：整期 3：青少年 4：个人定制化 5：团体定制化
      this.ruleForm.type = type
      this.ruleForm.typeId = id
      this.classSeting.date = ''
      this.classSeting.strTime = ''
      this.classSeting.endTime = ''
      this.classSeting.spaceName = ''
      //   console.log(id)
      if (type === 'add') {
        this.ruleForm.trainRefundList = []
        this.coachForm.id = ''
        this.courseInfo = {}
        this.ruleForm.trainCourseList = []
        this.coachForm = {}
        this.clearFrom()
      }
      if (type === 'update' || type === 'copyNew') {
        this.dataformLIST(id, type)
      }
    },
    // 清除表单验证
    clearFrom () {
      this.$nextTick(() => {
        this.$refs['coachFormRef'].clearValidate()
        this.$refs['courseInfoRef'].clearValidate()
      })
    },
    // 如果是修改先获取详情
    dataformLIST (id, type) {
      this.$http({
        url: this.$http.adornUrl(`/pxSubscribe/info/` + id),
        method: 'get'
      }).then((data) => {
        if (data && data.code === 0) {
          this.ruleForm.trainRefundList =
            data.data.businessRefundVOList === null
              ? []
              : data.data.businessRefundVOList
          this.ruleForm.trainRefundListsave =
            data.data.businessRefundVOList === null
              ? []
              : data.data.businessRefundVOList
          this.courseInfo = data.data.pxSubscribeCoachCourseVO
          this.ruleForm.trainCourseList =
            data.data.subscribeCoachTimeVOList === null
              ? []
              : data.data.subscribeCoachTimeVOList
          this.ruleForm.trainCourseListsave =
            data.data.subscribeCoachTimeVOList === null
              ? []
              : data.data.subscribeCoachTimeVOList
          this.coachForm.id = data.data.pxCoachSimpleVO.id
          this.ruleForm.id = data.data.id
          this.coachForm.coachName = data.data.pxCoachSimpleVO.name
          this.changeCity(data.data.pxCoachSimpleVO.id)
          this.clearFrom()
          let CourseListsave = this.ruleForm.trainCourseList
          if (type === 'copyNew') {
            for (var i = 0; i < CourseListsave.length; i++) {
              let time = CourseListsave[i].date + ' ' + this.screenTime(CourseListsave[i].time)
              console.log(time)
              console.log(this.TimeConversion(time))
              if (!this.TimeConversion(time)) {
                this.ruleForm.trainCourseList = []
                return
              }
            }
          }
        }
      })
    },
    screenTime (time) {
      let screentime = time.split('-')
      return screentime[1]
    },
    // 时间转成毫秒数
    TimeConversion (time) {
      // starttime = '2012-12-25 20:17:24'
      let starttime = time.replace(new RegExp('-', 'gm'), '/')
      var starttimeHaoMiao = (new Date(starttime)).getTime() //得到毫秒数
      let nowtime = Date.now()
      if (starttimeHaoMiao > nowtime) {
        return true
      } else {
        return false
      }
    },
    closeForm () {
      this.visible = false
      setTimeout(() => {
        this.loading = false
      }, 500)
    },
    pxTimeSd () {
      let datetime = new Date()
      let mi = datetime.getMinutes()
      let ho = datetime.getHours()
      if (mi === 0) {
        mi = 59
        ho = ho - 1
      } else {
        mi = mi - 1
      }
      let m = (ho + '').padStart(2, '0') + ':' + (mi + '').padStart(2, '0')
      let nyr =
        datetime.getFullYear() +
        '-' +
        (datetime.getMonth() + 1 + '').padStart(2, '0') +
        '-' +
        (datetime.getDate() + '').padStart(2, '0')
      console.log(this.classSeting.date, nyr, '+++++++++++++++++++')
      if (this.classSeting.date === nyr) {
        this.pxmintime = m
      } else {
        this.pxmintime = ''
      }
    },
    // 培训其实时间改变结束时间重置
    strTimeChange (val) {
      this.classSeting.endTime = ''
    },
    spaceNameBlur () {
      //   if (
      //     this.classSeting.spaceName &&
      //     !/^[0-9]*[1-9][0-9]*$/.test(this.classSeting.spaceName)
      //   ) {
      //     this.$message.error('培训场地编码请输入正整数！')
      //     this.classSeting.spaceName = ''
      //   }
    },
    // 添加课程
    addClaseSeting () {
      // 单次培训只能添加一节课
      if (!this.classSeting.date) {
        return this.$message.error('培训日期不能为空!')
      }
      if (!this.classSeting.strTime) {
        return this.$message.error('起始时段不能为空!')
      }
      if (!this.classSeting.endTime) {
        return this.$message.error('结束时段不能为空!')
      }
      if (!this.classSeting.spaceName) {
        return this.$message.error('预约场地不能为空!')
      }
      // if (!this.classSeting.spaceName) { return this.$message.error('场地编号不能为空!') }

      let item = {
        date: this.classSeting.date,
        strTime: this.classSeting.strTime,
        endTime: this.classSeting.endTime,
        spaceName: this.classSeting.spaceName,
        time: this.classSeting.strTime + '-' + this.classSeting.endTime
      }
      if (
        !this.nopeatClass(
          this.ruleForm.trainCourseList,
          item.date + ' ' + item.strTime,
          item.date + ' ' + item.endTime,
          item.spaceName
        )
      ) {
        return this.$message.error('课程时间不能重叠，请重新设置！')
      }
      this.ruleForm.trainCourseList.push(item)
      // this.classSeting.date = ''
      // this.classSeting.strTime = ''
      // this.classSeting.endTime = ''
      // this.classSeting.spaceName = ''
      this.ruleForm.trainCourseList.forEach((e, i) => {
        e.code = i + 1
      })
    },
    classCheck (val) {
      this.checkedClass = val
    },
    //删除课程
    delClassSeting () {
      if (this.checkedClass.length < 1) {
        return this.$message.error('请勾选至少一项课程！')
      }
      let arr = []
      this.checkedClass.forEach((e) => {
        arr.push(e.code)
      })
      console.log(this.ruleForm.trainCourseList)
      console.log(arr)
      this.ruleForm.trainCourseList = this.ruleForm.trainCourseList.filter(
        (e) => arr.indexOf(e.code) === -1
      )
    },
    //课程时间不能重叠   
    nopeatClass (list, nowTime, endTime, code) {
      console.log(list)
      console.log(nowTime)
      console.log(code)
      //   alert(1)
      let max = true
      let now = new Date(nowTime).getTime()
      let end = new Date(endTime).getTime()
      list.forEach((e) => {
        if (
          e.spaceName == code &&
          max &&
          !(new Date(e.date + ' ' + e.endTime).getTime() < now ||
            new Date(e.date + ' ' + e.strTime).getTime() > end
          )
        ) {
          max = false
        }
      })
      console.log(now, max, 998)
 
      return max
    },
    //退款设置添加事件
    addCtRefund () {
      // if (!this.tMoneyStr) { return this.$message.error('报名距培训开始时间不能为0!') }
      // if (!this.tmoneyBL) return this.$message.error('退款比例不能为空!')

      let item = {
        // id: new Date().getTime(),
        hours: this.tMoneyStr,
        rate: this.tmoneyBL
      }
      this.ruleForm.trainRefundList.push(item)
      this.tMoneyStr = ''
      this.tmoneyBL = ''
    },
    //退款设置删除事件
    delCtRefund () {
      let arr = []
      this.delTableList.forEach((e) => {
        arr.push(e.id)
      })
      let arrs = this.ruleForm.trainRefundList
      this.ruleForm.trainRefundList = arrs.filter(
        (e) => arr.indexOf(e.id) === -1
      )
    },
    // table多选事件
    selectionChangeHandle (val) {
      this.delTableList = val
      if (this.delTableList.length === 0) {
        this.delCtRefundDisabled = true
      } else {
        this.delCtRefundDisabled = false
      }
    },
    //选择模板
    addFeeTemplate (type) {
      this.addFeeTemplateVisible = true
      this.$nextTick(() => {
        this.$refs.addFeeTemplate.init(type)
      })
    },
    // 选择模板完成  type:1费用模板 2退款模板
    chooseTemplate (list, type) {
      console.log(list, type)
      if (type === 1) {
        this.bmFreeDo(list)
      }
      if (type === 2) {
        this.tkFeeDo(list)
      }
    },
    //退费列表赋值处理
    tkFeeDo (list) {
      let arrT = []
      let itemT = {}
      list.forEach((e) => {
        itemT = {
          id: e.id,
          hours: e.typeVal,
          rate: e.value
        }
        arrT.push(itemT)
      })
      this.ruleForm.trainRefundList = arrT
    },
    // 调用出每一个里面的id
    getIdArray (item) {
      let arr = []
      if (item != null) {
        for (let i = 0; i < item.length; i++) {
          arr.push(item[i].id)
        }
        console.log(arr)
        return arr
      } else {
        return item
      }
    },
    selectionSitePriceDetailHandle () { }
  }
}
</script>
<style scoped>
/* .blackimg {
  font-size: 60px;
}
.lab {
  width: 20%;
} */
.inputWidths {
  width: 20%;
}
.fontStyle {
  font-weight: bold;
  font-size: 18px;
}
.width_ct {
  width: 50%;
}
.sel_width_ct,
.input_width_ct {
  width: 20% !important;
}
.son-container {
  flex-grow: 1;
  display: flex;
  margin-bottom: 20px;
}
.container {
  display: flex;
  justify-content: space-between;
}
.sport-experience {
  width: 90%;
  height: 200px;
  padding: 10px;
  overflow-y: auto;
  border: 1px solid #dcdfe6;
  background-color: #f5f7fa;
  border-radius: 4px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.coachImage {
  width: 50px;
  height: 50px;
}
.costnumber {
  margin-left: 10px;
}
</style>
